import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Preloads only routes explicitly flagged with `data: { preload: true }`, in the background after
 * the initial navigation. This keeps lazy loading's startup benefit while making flagged routes
 * (e.g. cost-comparison) instant on first click — no on-demand chunk load that would otherwise
 * delay the tab switch. Preferred over `PreloadAllModules` so preloading stays intentional and
 * scoped as the app grows.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] === true ? load() : of(null);
  }
}
